import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

const isFieldRequiredInImports = (field: IField) =>
  !field.hasFeature(FieldFeature.NON_IMPORT) &&
  ((field.isSystemRequired && field.importProperties?.required !== false) ||
    field.importProperties?.required === true);

export default isFieldRequiredInImports;
